module.exports = __webpack_public_path__ + "img/va.eb77a306.svg";